import { render } from "./dl-header.vue?vue&type=template&id=5c9c7b24"
import script from "./dl-header.vue?vue&type=script&lang=js"
export * from "./dl-header.vue?vue&type=script&lang=js"

import "./dl-header.vue?vue&type=style&index=0&id=5c9c7b24&lang=scss"

import exportComponent from "/var/www/doctolib-hos-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__